import React from 'react';

import { Modal, ModalContent, ModalHeader, ModalTitle } from '@epoch-ui/components/Modal/modal';
import { usePublishErrorsModal } from '@event-editor/hooks/eventEditorState';

import { ScheduleImpactCard } from '../ScheduleImpactCard/ScheduleImpactCard';

export const PublishErrorsModal = (): React.ReactElement => {
  const { isDetailsModalOpen, toggleErrorsDetailsModal, errors } = usePublishErrorsModal();

  return (
    <Modal open={isDetailsModalOpen} onOpenChange={(open) => !open && toggleErrorsDetailsModal()}>
      <ModalContent size="md">
        <ModalHeader>
          <ModalTitle>Scheduled features</ModalTitle>
        </ModalHeader>

        <div className="tw-flex tw-flex-col tw-gap-4">
          <p className="tw-m-0 tw-text-sm tw-leading-5 tw-text-black">
            This event can’t be published because the scheduled time of the following is in the
            past.
          </p>

          <div className="tw-flex tw-flex-col tw-gap-2">
            {errors.map((error, index) => (
              <ScheduleImpactCard key={index} {...error} />
            ))}
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};
